import {h, Fragment} from "preact"
import { useActions } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'

import Filter from "./Filter"

const facetNameTranslations = {
    category: 'Kategoria',
    brand: 'Producent',
    inStock: 'Available'
}

export default ({ facet, isActive, setActive }) => {
    const { updateSearch } = useActions()

    const selectedFiltersCount =
        facet.data?.filter((v) => v.selected).length ?? 0

    return (
        <li class={`ns-sidebar-dropdown ${isActive ? 'ns-active' : ''}`}>
            <a
                class="nosto-sidebar-dropdown ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated"
                href="javascript:void(0)"
                onClick={() => {
                    setActive(!isActive)
                }}>
                <span class="ns-color-link ns-font-4">
                    {facet.name}
                </span>
                {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-2 ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">{selectedFiltersCount}</span>
                )}
                <i class="ns-icon ns-icon-arrow ns-absolute"></i>
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-p-4">
                <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                {facet.data?.filter(val => !val.value.toString().includes(":")).map((value) => (
                        <Filter
                            value={value}
                            facet={facet} 
                        />
                    ))}
                </ul>
            </div>
        </li>
    )
}
